<template>
<div id="app">
    <div id="app">
        <router-view />
    </div>
</div>
</template>

<script>
import Firebase from './lib/Firebase'
export default {
    name: 'app',

    /* created() {
        var uid = Firebase.auth().currentUser.uid;
        var userStatusDatabaseRef = Firebase.database().ref('/users/' + uid);

        var isOfflineForDatabase = {
            state: 'offline',
            last_changed: new Date(),
        };

        var isOnlineForDatabase = {
            state: 'online',
            last_changed: new Date(),
        };

        // [END_EXCLUDE]
        var userStatusFirestoreRef = Firebase.firestore().doc('/users/' + uid);

        // Firestore uses a different server timestamp value, so we'll 
        // create two more constants for Firestore state.
        var isOfflineForFirestore = {
            state: 'offline',
            last_changed: new Date(),
        };

        var isOnlineForFirestore = {
            state: 'online',
            last_changed: new Date(),
        };

        Firebase.database().ref('.info/connected').on('value', function (snapshot) {
            if (snapshot.val() == false) {
                // Instead of simply returning, we'll also set Firestore's state
                // to 'offline'. This ensures that our Firestore cache is aware
                // of the switch to 'offline.'
                userStatusFirestoreRef.update(isOfflineForFirestore);
                return;
            };

            userStatusDatabaseRef.onDisconnect().set(isOfflineForDatabase).then(function () {
                userStatusDatabaseRef.set(isOnlineForDatabase);

                // We'll also add Firestore set here for when we come online.
                userStatusFirestoreRef.upadte(isOnlineForFirestore);
            });
        });
    }, */
}
</script>

<style lang="scss">


@import './sass/app';

/* @import 'https://fonts.googleapis.com/css?family=Nunito'; */
#app {
    background-color: #ffffff !important;
    height: 100%;

    /*  font-family: 'Nunito', sans-serif; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue